import Cookies from "js-cookie"

const Popup = () => {
  const acceptLink = document.querySelector(".js-close-popup")
  const notice = document.querySelector(".js-popup")
  if (acceptLink && notice) {
    window.setTimeout(() => {
      notice.classList.add("c-popup--active")
    }, 5000)
    acceptLink.addEventListener("click", e => {
      e.preventDefault()
      Cookies.set("bronkhorst_closed_popup", 1)
      remove(notice)
    })
  }

  /**
   * Remove an element from the the dom
   */
  const remove = element => {
    element.parentNode.removeChild(element)
  }
}

export default Popup



// WEBPACK FOOTER //
// ./src/js/modules/Popup.js